import SetForecastComment from "./SetForecastComment";

export default SetForecastComment;
